import { Fetch } from 'lib';
import type { Catalog, CatalogFileSummary } from 'types';

type RequestResponses = Catalog;

type RequestParameters = {};

type RequestBody = Pick<Catalog, 'description' | 'seo'> &
  Record<'brandId', string> &
  Record<'catalogs', CatalogFileSummary[]>;

const createCatalog = async (body: RequestBody) =>
  await Fetch<RequestResponses, RequestParameters, RequestBody>({
    url: 'adminCatalog/createCatalog',
    method: 'POST',
    body,
  });

export { createCatalog };
